query findEventRotationIdByEvent(
  $id: UUID!
) {
  event: eventRotationIdByEventId(eventId: $id) {
    awayRotationId
    homeRotationId
    source
  }
}
